require('./lbaTagSelect.scss');

const $inject = [];

const lbaTagSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaTagSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaTagSelect.html')
  }
};

lbaTagSelect.$inject = $inject;

export default lbaTagSelect;



// WEBPACK FOOTER //
// ./src/components/lbaTagSelect/lbaTagSelectDir.js